import { Navigate } from 'react-router-dom';
import { GuidesPage } from '@/features/guides/pages/GuidesPage';
import { GuideDetailPage } from '@/features/guides/pages/GuideDetailPage';
import { GuideBookingPage } from '@/features/booking/pages/GuideBookingPage';
import { PaymentReturnPage } from '@/features/booking/pages/PaymentReturnPage';
import { BookingConfirmationPage } from '@/features/booking/pages/BookingConfirmationPage';
import { MyBookingsPage } from '@/features/booking/pages/MyBookingsPage';

export const guidesPublicRoutes = [
  { path: 'guides', element: <GuidesPage /> },
  { path: 'guides/:guideId', element: <GuideDetailPage /> },
];

export const bookingRoutes = [
  { path: 'guides/:guideId/book', element: <GuideBookingPage /> },
  { path: 'payment/return', element: <PaymentReturnPage /> },
  { path: 'bookings/:bookingId/confirmation', element: <BookingConfirmationPage /> },
  { path: 'bookings', element: <Navigate to="/my-bookings" replace /> },
  { path: 'my-bookings', element: <MyBookingsPage /> },
];
